export default __webpack_public_path__ + "static/media/activeIcon.6c508b3f.svg";